<template>
    <div>
        <tabler :height="height" :options="options" :params="params" :ref="'commenttabler'" @load='commentsloaded'>
          <template v-slot:fileid="{ item }">
            <a v-if="(item.fileid!=null)&&(item.fileid!=0)" :href="item.fileurl?item.fileurl:('headless.php?action=import_getImportFile&id='+item.fileid)" :title="item.filename">
              <span class="glyphicon glyphicon-paperclip"></span>
            </a>
          </template>
        </tabler>
        <div class="input-group fullwidth">
            <input class="form-control" placeholder="Новый комментарий..." v-model="newcomment" :disabled="commentadded"/>
            <span class="input-group-btn">
                <button class="btn btn-info btn-sm" v-on:click="addNewComment" :disabled="commentadded"><span class="glyphicon glyphicon-comment"></span> Добавить</button>
            </span>
        </div>
        <div v-if="fileupload" class="fullwidth filezone">
          <dropzone :options="commentFileOptions" ref="commentfilezone" use-custom-slot="true" @vdropzone-success="newCommentFileUploaded">
            <div class="dropzone-custom-content">
              <h3 class="dropzone-custom-title">Добавить файл</h3>
            </div>
          </dropzone>
        </div>
    </div>
</template>

<style>
  div.vue-dropzone{
    height:150px;
    background: lightgray;
  }
  div.dz-details, div.dz-image{
    max-height: 100px;
  }
</style>

<script>
    import tabler from './tabler.vue'
    import axios from 'axios'

    export default {
        props: ['height','query','addquery','param','fileupload','comments'],
        data:function(){
            return {
                newcomment:"",
                commentadded:false,
                commentFileOptions:{
                  url:"headless.php?action=import_uploadImportFile",
                  addRemoveLinks:true,
                  dictCancelUpload:"{t}Отмена{/t}",
                  dictCancelUploadConfirmation:"{t}Отменить загрузку{/t}?",
                  dictRemoveFile:"{t}Удалить файл{/t}",
                  timeout:3600000,
                  autoProcessQueue:true
                },
                fileid:null
            }
        },
        computed:{
            commentcount(){
                return this.$refs["commenttabler"].items.length;
            },
            params(){
              if (this.comments!=null)
                return this.comments;
              return { id:this.param };
            },
            options(){
              let columns=[
                { title:"Время",field:"commenttime",dateformat:"DD.MM.YYYY HH:mm" },
                { title:"Автор",field:"commenterFIO" },
                { title:"Комментарий",field:"commenttext" }
              ];
              if (this.fileupload!=null)
                columns.push({ title:"Файл",field:"fileid" });
              return {
                columns: columns,
                query:this.query
              }
            }
        },
        methods:{
            addNewComment:function(){
                if (this.newcomment.trim()=="")
                    return;
                var vars=new FormData();
                vars.set('action',this.addquery);
                vars.set('id',this.param);
                vars.set('commenttext',this.newcomment);
                if (this.fileupload!=null)
                  vars.set(this.fileupload,this.fileid);
                this.commentadded=true;
                axios.post("headless.php?action="+this.addquery,vars).then((d)=>{
                    this.$emit("comment-added",d);
                    this.$refs["commenttabler"].refresh();
                });
            },
            refresh:function(){
                this.$refs["commenttabler"].refresh();
            },
            commentsloaded()
            {
                this.$emit("commentsloaded",this.$refs["commenttabler"].items.length);
            },
            newCommentFileUploaded(d){
              var j=JSON.parse(d.xhr.response);
              this.fileid=j.id;
            }
        }
    }
</script>